module.exports = __webpack_public_path__ + "static/media/work7.b9d2cd4c.jpg";